import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { SiteField } from '@/@vxapp/@Enums/PHP/ServicesV2/Sites/Enums/SiteField'

export const SitesTableActions = [
  {
    id: 'preview',
    title: 'Preview',
    tooltip: 'Preview Site',
    icon: 'tabler-eye',
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: 'apps-sites-preview-guid',
      paramKey: 'guid',
      itemKey: SiteField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
  {
    id: 'edit',
    title: 'Edit',
    tooltip: 'Edit Site',
    icon: 'tabler-pencil',
    color: 'secondary',
    disabled: false,
    hidden: false,
    route: {
      name: 'apps-sites-edit-guid',
      paramKey: 'guid',
      itemKey: SiteField.DB_IDENTIFIER,
    },
    emit: 'edit',
  },
  {
    id: 'delete',
    title: 'Delete',
    tooltip: 'Delete Site',
    icon: 'tabler-trash',
    color: 'error',
    disabled: false,
    hidden: false,
    emit: 'delete',
  },
] as const satisfies readonly TableActionSpec[]
